function toggleSelector(){

    "use strict";

    var TOGGLE_BTN = '.toggle-js',
        TOGGLE_ACTIVE = 'toggle-active',
        TOGGLE_CONTAINER = '.toggle-container',
        TOGGLE_CONTAINER_EXPANDED = 'toggle-container--expanded';

    $( TOGGLE_BTN ).on('click', onClick);

    function onClick(event) {
        $( TOGGLE_BTN + '[data-togglegroup=' + this.getAttribute('data-togglegroup') + ']' ).each(function (index) {
           $(this).removeClass(TOGGLE_ACTIVE);
        });
        $( TOGGLE_CONTAINER + '[data-togglegroup=' + this.getAttribute('data-togglegroup') + ']' ).each(function (index) {
            if ($( this ).hasClass( 'no-animation' )) {
                $(this).hide();
            }
            else {
                $(this).slideUp();
            }
            $(this).removeClass(TOGGLE_CONTAINER_EXPANDED);
        });
        $( TOGGLE_CONTAINER + '[data-toggle=' + this.getAttribute('data-toggle') + ']' ).each(function (index) {
            if ($( this ).hasClass( 'no-animation' )) {
                $(this).show();
            }
            else {
                $(this).slideDown();
            }
            $(this).addClass(TOGGLE_CONTAINER_EXPANDED);
        });
        $(this).toggleClass(TOGGLE_ACTIVE);
    }
}

module.exports = toggleSelector;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/05_toggle.js